import StandNoteEditForm from "./stand-note-edit-form";

export default StandNoteEditForm;